<template>
  <div id="aftersale" v-loading="loading">
    <div class="statistic">
      共 {{ pagination.totalCount }} 条记录， 退款合计：{{ returnTotal.amount.toFixed(2) }}, 挂账合计: {{ returnTotal.amountCredit.toFixed(2) }}, 现金合计: {{ (returnTotal.amount - returnTotal.amountCredit).toFixed(2) }}
    </div>
    <form class="row search-pannel" :class="{ fold: fold}" @submit.prevent="doQuery">
      <input type="submit" style="display:none" />
      <div class="col-sm-3">
        <el-input size="small" v-model="query.refundSn" placeholder="退款编号" clearable @input="(val) => query.refundSn = val.replace(/\s/g, '')" />
      </div>
      <div class="col-sm-3">
        <el-input size="small" v-model="query.orderSn" placeholder="订单编号" clearable @input="(val) => query.orderSn = val.replace(/\s/g, '')" />
      </div>
      <div class="col-sm-3">
        <el-input size="small" v-model="query.buyer" placeholder="买家名称/买家手机号" clearable />
      </div>
      <div class="col-sm-3">
        <el-select size="small" v-model="query.state" placeholder="退款状态" clearable>
          <el-option label="全部退款" :value="0" />
          <el-option label="待确认" :value="1" />
          <el-option label="退款中" :value="2" />
          <el-option label="已退款" :value="4" />
          <el-option label="已取消" :value="-1" />
        </el-select>
      </div>
      <div class="col-sm-3">
        <el-date-picker size="small" v-model="query.applyTimeStart" value-format="yyyy-MM-dd" placeholder="发起时间-开始" clearable>
        </el-date-picker>
      </div>
      <div class="col-sm-3">
        <el-date-picker size="small" v-model="query.applyTimeEnd" value-format="yyyy-MM-dd" placeholder="发起时间-结束" clearable>
        </el-date-picker>
      </div>
      <div class="col-sm-3">
        <el-date-picker size="small" v-model="query.completeTimeStart" value-format="yyyy-MM-dd" placeholder="退款时间-开始" clearable>
        </el-date-picker>
      </div>
      <div class="col-sm-3">
        <el-date-picker size="small" v-model="query.completeTimeEnd" value-format="yyyy-MM-dd" placeholder="退款时间-结束" clearable>
        </el-date-picker>
      </div>
      <div class="folder">
        <el-button type="primary" size="small" @click="doQuery">确定</el-button>
        <el-button type="default" size="small" @click="doReset">重置</el-button>
        <el-button style="float: right" size="small" type="text" @click="fold = !fold">{{ fold ? '展开' : '收起' }}<i v-if="fold" class="crm-icon-arrow-down" /><i v-else class="crm-icon-arrow-up" /></el-button>
      </div>
    </form>
    <div v-if="list && list.length" class="data-list">
      <div v-for="item in list" :key="item.id" class="order-item-wraper">
        <refund-item :refund-order="item" @startLoading="loading=true" @endLoading="loading=false" />
      </div>
    </div>
    <div v-else class="data-list">
      <div class="no-data">
        暂无数据
      </div>
    </div>
    <div class="page-footer">
      <el-pagination
        background
        layout="prev, pager, next"
        :pager-count="5"
        :current-page.sync="pagination.pageIndex"
        :total="pagination.totalCount"
        :page-size.sync="pagination.pageSize"
        @current-change="updateRoute"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import RefundItem from './AfterSaleItem.vue'
import { ListRefund } from './services.js'
import moment from 'moment'
export default {
  name: 'RefundList',
  components: { RefundItem },
  data () {
    const lastYear = moment().subtract(1, 'year').format('YYYY-MM-DD')
    const today = moment().format('YYYY-MM-DD')
    return {
      fold: true,
      loading: false,
      query: {
        refundSn: '',
        orderSn: '',
        buyer: '',
        state: 0,
        applyTimeStart: lastYear,
        applyTimeEnd: today,
        completeTimeStart: undefined,
        completeTimeEnd: undefined
      },
      list: [],
      returnTotal: { amount: 0, amountCredit: 0 },
      pagination: {
        pageIndex: 1,
        pageSize: 20,
        totalCount: 0
      }
    }
  },
  computed: {
    buyerId () {
      return this.$route.query.buyerId ? +this.$route.query.buyerId : 0
    },
    queryStr () {
      return this.$route.query
    }
  },
  watch: {
    queryStr: {
      handler (newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.updateQuery()
          this.doLoadData()
        }
      },
      deep: true
    },
    newAdd () {
      this.doLoadData()
    },
    area () {
      this.doLoadData()
    }
  },
  created () {
    this.updateQuery()
  },
  mounted () {
    this.doLoadData()
  },
  methods: {
    doQuery () {
      this.pagination.pageIndex = 1
      this.updateRoute()
    },
    updateQuery () {
      const lastYear = moment().subtract(1, 'year').format('YYYY-MM-DD')
      const { orderSn, refundSn, buyer, state, applyTimeStart, applyTimeEnd, completeTimeStart, completeTimeEnd, pageIndex, pageSize } = this.$route.query
      this.query.orderSn = orderSn
      this.query.refundSn = refundSn
      this.query.buyer = buyer
      this.query.state = +state || 0
      this.query.applyTimeStart = applyTimeStart || undefined
      this.query.applyTimeEnd = applyTimeEnd || undefined
      this.query.completeTimeStart = completeTimeStart || lastYear
      this.query.completeTimeEnd = completeTimeEnd || undefined
      this.pagination.pageIndex = (+pageIndex && +pageIndex > 0) ? +pageIndex : 1
      this.pagination.pageSize = (+pageSize && +pageSize > 0) ? +pageSize : 30
    },
    updateRoute () {
      const { pageIndex, pageSize } = this.pagination
      const { orderSn, refundSn, buyer, state, applyTimeStart, applyTimeEnd, completeTimeStart, completeTimeEnd } = this.query
      this.$router.push({
        query: { buyerId: this.buyerId, orderSn, refundSn, buyer, state, applyTimeStart, applyTimeEnd, completeTimeStart, completeTimeEnd, pageIndex, pageSize, t: new Date().getTime() }
      })
      this.doLoadData()
    },
    doLoadData () {
      if (this.loading) return
      this.loading = true
      const { pageIndex, pageSize } = this.pagination
      const { orderSn, refundSn, buyer, state, applyTimeStart, applyTimeEnd, completeTimeStart, completeTimeEnd } = this.query
      ListRefund({
        orderSn: orderSn || undefined,
        refundSn: refundSn || undefined,
        buyer: this.buyerId ? undefined : buyer || undefined,
        state: state || 0,
        applyTimeStart: applyTimeStart || undefined,
        applyTimeEnd: applyTimeEnd || undefined,
        completeTimeStart: completeTimeStart || undefined,
        completeTimeEnd: completeTimeEnd || undefined,
        buyerId: this.buyerId,
        newAdd: this.newAdd,
        area: this.area || undefined,
        pageIndex,
        pageSize
      }).then((resp) => {
        this.list = resp.items
        const { pageIndex, pageSize, totalCount } = resp.pagination
        this.returnTotal = resp.returnTotal
        this.pagination.pageIndex = pageIndex
        this.pagination.pageSize = pageSize
        this.pagination.totalCount = totalCount
      }).finally(() => {
        this.loading = false
      })
    },
    doReset () {
      const lastYear = moment().subtract(1, 'year').format('YYYY-MM-DD')
      this.pagination = {
        pageIndex: 1,
        pageSize: 20,
        totalCount: 0
      }
      if (this.buyerId) {
        this.$router.push({ query: {
          t: new Date().getTime()
        } })
      } else {
        this.query = {
          refundSn: '',
          orderSn: '',
          buyer: '',
          state: 0,
          applyTimeStart: lastYear,
          applyTimeEnd: undefined,
          completeTimeStart: undefined,
          completeTimeEnd: undefined
        }
      }
      this.updateRoute()
    }
  }
}
</script>
